// Company insight slice

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";
import { IWebScrapData } from "../company-registration/companyRegistrationSlice";

export interface ICompanyInsightInfo {
  answers?:{ [key: string]: any};//ICompanyAnswerInfo;
  webscrapParseList ?: IWebScrapData<any>[];
  recommendations?:string;
  executionId?: string;
}

const initialState: ICompanyInsightInfo = {
  answers:{
    branch_information: "",
  },
  recommendations:""
};

export interface ICompanyAnswerInfo{
    branch_information?: string;
    company_name?: string;
    contact_number?:string;
    country?:string;
    email_address?:string;
    location?: string;
    other_important_insights?: string[];
    product_details?: string[];
    services?: string[];
    social_media_presence?: {};
    vision?:string;
}


export const companyInsightSlice = createSlice({
  name: "companyInsight",
  initialState,
  reducers: {
    updateCompanyInsight: (
      state,
      action: PayloadAction<ICompanyInsightInfo>
    ) => {
      return { ...state, ...action.payload };
    },
    // updateAIGeneratedCompanyInsight: (
    //   state,
    //   action: PayloadAction<ICompanyInsightInfo>
    // ) => {
    //   return { ...state, ...action.payload };
    // },
  },
});

export const { updateCompanyInsight } = companyInsightSlice.actions;
export const companyInsightSelector = (state: RootState) =>
  state.commanyInsightReducer;
export default companyInsightSlice.reducer;